import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import {
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  ViewChild,
  ElementRef,
  Input,
} from '@angular/core';
import { from, of, Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  finalize,
  switchMap,
  takeUntil,
} from 'rxjs/operators';
import { Router, NavigationStart } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ComponentCanDeactivate } from '../../../component-can-deactivate';
import { driversLicenceOptions } from 'src/app/models/driversLicenceOptions';
import { countryIds } from 'src/app/models/countryIds';
import { UpdateCandidate , Address} from 'src/app/models/UpdateCandidate';
import { ValidationService } from 'src/app/services/validation.service';
import { dateToTimestamp } from 'src/commons/date-utils';
import { PostcodeValidationService } from 'src/app/services/postcode-validation.service';
import { states } from 'src/commons/constants';
@Component({
  selector: 'app-candidate-details',
  templateUrl: './candidate-details.component.html',
  styleUrls: ['./candidate-details.component.css'],
})
export class CandidateDetailsComponent
  implements OnInit, OnDestroy, ComponentCanDeactivate {
  @Input() candidateID: string = '';
  @ViewChild('btnSwitchTab') btnSwitchTab!: ElementRef;
  @ViewChild('closeNav') closeNav!: ElementRef;
  @ViewChild('closeModelProfile') closeModelProfile!: ElementRef;

  formSession: boolean = false;
  UnSavedPopUp: boolean = false;
  displayLoader: boolean = true;
  update: boolean = false;
  saving: boolean = false;
  navigate: boolean = false;
  mobileView: boolean = false;
  savedetailsModal: boolean = false;
  updatecandidate!: UpdateCandidate;
  profile: any;
  name: any;
  email: any;
  lastname: any;
  preferred_lang: string = 'Spanish';
  dateOfBirth: any;
  rawCustomDate6: any;
  message: string = 'Saving the Details..';
  url: any;
  BullhornMeta: any;
  namePrefixes: any;
  customText11: any;
  selected: string = 'profile';
  id: string = '';
  profilecompleted: any;
  pageName: any;
  driversLicenceOptions =driversLicenceOptions;
  countryIds = countryIds;
  stateOptions = [...states];
  cityOptions: string[] = [];
  postcodeOptions: string[] = [];
  cityPage = 1;
  cityHasMore = false;
  cityIsLoadingMore = false;
  citySearchTerm = '';
  citySearchLoading = false;
  cityTypeahead$ = new Subject<string>();
  cityError = '';
  postcodeError = '';
  stateError = '';

  get addressTooltip(): string {
    if (this.stateError) return this.stateError;
    if (!this.profile?.candidateAddressState) return 'Please select a state';
    if (this.cityError) return this.cityError;
    if (!this.profile?.candidateAddressCity) return 'Please select a city/suburb';
    if (this.postcodeError) return this.postcodeError;
    if (!this.profile?.zip) return 'Please select a postcode';
    return '';
  }

  canDeactivate(): boolean {
    if (this.navigate) {
      this.UnSavedPopUp = false;
      return true;
    } else if (this.update) {
      this.UnSavedPopUp = true;
      return false;
    }
    return true;
  }

  addItem(newItem: string) {
    this.profile = newItem;
  }
  title = 'FrontendService';
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  toggleSidebar() {
    var menu = document.querySelector('.page-container');
    menu?.classList.toggle('sbar_collapsed');
  }

  closeSidebar() {
    var menu = document.querySelector('.page-container');
    menu?.classList.add('sbar_collapsed');
  }

  nextUrl(pageName: string) {
    this.url = pageName;
  }

  navigateUrl() {
    this.navigate = true;
    var url = this.url;
    this.router.navigate([url]);
  }

  constructor(
    private router: Router,
    private http: HttpClient,
    private validationService:ValidationService,
    private postcodeValidationService: PostcodeValidationService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) { }

  ngOnInit(): void {
    let api = '/admin/Candidates/' + this.candidateID;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (window.screen.width <= 768) {
          //('navigation starts...', window.screen.width);
          this.mobileView = true;
        }
      }
    });

    this.cityTypeahead$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term: string) => {
          const state = this.profile?.candidateAddressState;
          if (!state) {
            return of({ items: [] as string[], hasMore: false });
          }
          const q = (term ?? '').trim();
          this.citySearchTerm = q;
          this.cityPage = 1;
          this.citySearchLoading = true;
          return from(
            this.postcodeValidationService.fetchSuburbsPage(
              state,
              1,
              q || undefined
            )
          ).pipe(finalize(() => (this.citySearchLoading = false)));
        }),
        takeUntil(this._destroying$)
      )
      .subscribe(({ items, hasMore }) => {
        this.cityOptions = items;
        this.cityPage = 1;
        this.cityHasMore = hasMore;
      });

    this.getProfile(environment.apiConfig.uri + api);
  }

  getProfile(url: string) {
    this.http.get(url).subscribe(async (profile: any) => {
      this.profile = profile.data;
      if (this.profile.candidateAddressState && !this.postcodeValidationService.isKnownState(this.profile.candidateAddressState)) {
        this.stateError = 'This state is not a recognized Australian state. Please re-select.';
      }
      if (this.profile.candidateAddressState && !this.stateError) {
        let { items, hasMore } = await this.postcodeValidationService
          .fetchSuburbsPage(this.profile.candidateAddressState, 1);
        const savedCity = this.profile.candidateAddressCity;
        if (savedCity && !this.postcodeValidationService.suburbInList(items, savedCity)) {
          const refined = await this.postcodeValidationService.fetchSuburbsPage(
            this.profile.candidateAddressState,
            1,
            savedCity
          );
          if (refined.items.length) {
            const extra = refined.items.filter(
              r => !this.postcodeValidationService.suburbInList(items, r)
            );
            if (extra.length) items = [...extra, ...items];
          }
        }
        this.citySearchTerm = '';
        this.cityOptions = items;
        this.cityPage = 1;
        this.cityHasMore = hasMore;
        if (savedCity) {
          const canonical = this.postcodeValidationService.findSuburb(items, savedCity);
          if (canonical && canonical !== savedCity) this.profile.candidateAddressCity = canonical;
        }
      }
      if (this.profile.candidateAddressCity && this.profile.candidateAddressState && !this.stateError) {
        this.postcodeOptions = await this.postcodeValidationService
          .getPostcodesBySuburbAndState(this.profile.candidateAddressCity, this.profile.candidateAddressState);
      }
      const city = this.profile.candidateAddressCity;
      const zip = this.profile.zip;
      if (!this.stateError) {
        if (city && this.cityOptions.length && !this.postcodeValidationService.suburbInList(this.cityOptions, city) && this.postcodeOptions.length === 0) {
          this.cityError = 'This suburb does not belong to the selected state.';
        }
        if (zip && this.postcodeOptions.length && !this.cityError && !this.postcodeOptions.includes(zip)) {
          this.postcodeError = 'This postcode does not match the suburb and state.';
        }
      }
      this.name = this.profile.firstName + ' ' + this.profile.lastName;
      this.email = this.profile.email;
      this.dateOfBirth = this.profile?.dateOfBirth;
      this.rawCustomDate6 = this.profile?.customDate6;
      this.BullhornMeta = JSON.parse(this.profile.bullhornMetaFields);
      const datepipe: DatePipe = new DatePipe('en-US');
      const formattedDate = datepipe.transform(
        this.profile?.dateOfBirth?.toString(),
        'yyyy-MM-dd'
      );
      this.profile.dateOfBirth = formattedDate;
      const formattedCustomDate6 = datepipe.transform(
        this.profile?.customDate6?.toString(),
        'yyyy-MM-dd'
      );
      this.profile.customDate6 = formattedCustomDate6;

      if (!this.profile.namePrefix) {
        this.profile.namePrefix = '';
      }
      if (!this.profile.gender) {
        this.profile.gender = '';
      }
      if (!this.profile.customText11) {
        this.profile.customText11 = '';
      }
      if (!this.profile.customText13) {
        this.profile.customText13 = '';
      }
      if (!this.profile.candidateAddressCountryId) {
        this.profile.candidateAddressCountryId = '';
      }
      this.displayLoader = false;
    });
  }

  updateInput(event: any) {
    this.formSession = true;
    if (this.update === false) {
      this.update = true;
    }
    if (!event) return;
    var attr = event.target.name;
    if (this.profile.attr === null || this.profile.attr === undefined) {
      this.profile.attr = '';
    }
    if (attr == 'customText11') {
      this.customText11 = event.target.value;
    }
  }

  async onStateChange(): Promise<void> {
    this.profile.candidateAddressCity = '';
    this.profile.zip = '';
    this.postcodeOptions = [];
    this.cityPage = 1;
    this.cityHasMore = false;
    this.stateError = '';
    this.cityError = '';
    this.postcodeError = '';
    if (this.profile.candidateAddressState) {
      const { items, hasMore } = await this.postcodeValidationService
        .fetchSuburbsPage(this.profile.candidateAddressState, 1);
      this.citySearchTerm = '';
      this.cityOptions = items;
      this.cityHasMore = hasMore;
    } else {
      this.cityOptions = [];
    }
    this.updateInput(null);
  }

  async loadMoreCities(): Promise<void> {
    if (this.cityIsLoadingMore || !this.cityHasMore || !this.profile.candidateAddressState) return;
    this.cityIsLoadingMore = true;
    try {
      const { items, hasMore } = await this.postcodeValidationService
        .fetchSuburbsPage(
          this.profile.candidateAddressState,
          this.cityPage + 1,
          this.citySearchTerm || undefined
        );
      this.cityOptions = [...this.cityOptions, ...items];
      this.cityPage++;
      this.cityHasMore = hasMore;
    } finally {
      this.cityIsLoadingMore = false;
    }
  }

  onCityScroll(event: { start: number; end: number }): void {
    if (event.end >= this.cityOptions.length - 1) {
      this.loadMoreCities();
    }
  }

  async onCityChange(): Promise<void> {
    this.profile.zip = '';
    this.postcodeOptions = (this.profile.candidateAddressCity && this.profile.candidateAddressState)
      ? await this.postcodeValidationService.getPostcodesBySuburbAndState(this.profile.candidateAddressCity, this.profile.candidateAddressState)
      : [];
    this.cityError = '';
    this.postcodeError = '';
    this.updateInput(null);
  }

  onPostcodeChange(): void {
    if (this.profile.zip && this.postcodeOptions.includes(this.profile.zip)) {
      this.postcodeError = '';
    }
    this.updateInput(null);
  }

  submitForm(data: any) {
    const emailsValid=this.validationService.validateEmail(data.email)
    if (!emailsValid) {
      this.message = 'Please correct the invalid email address before submitting.';
      this.saving = true;
      setTimeout(() => {
        this.saving = false;
      }, 1000);
      return;
    }
    this.stateError = '';
    this.cityError = '';
    this.postcodeError = '';
    const state = data.state || '';
    const city = data.city || '';
    const zip = data.zip || '';
    if (state && city && this.cityOptions.length && !this.postcodeValidationService.suburbInList(this.cityOptions, city) && this.postcodeOptions.length === 0) {
      this.cityError = 'This suburb does not belong to the selected state.';
    }
    if (city && state && !this.cityError && this.postcodeOptions.length && !this.postcodeOptions.includes(zip)) {
      this.postcodeError = 'This postcode does not match the suburb and state.';
    }
    if (this.cityError || this.postcodeError) {
      this.message = 'Please correct the address fields before submitting.';
      this.saving = true;
      setTimeout(() => { this.saving = false; }, 3000);
      return;
    }
    this.savedetailsModal = true;
    this.UnSavedPopUp = false;
    this.togglePopUp();
    const profileOBJ = <UpdateCandidate>{};
    const addressOBJ = <Address>{};
    for (var key in data) {
      var value = data[key];
      if (key == 'address1') {
        addressOBJ.address1 = value;
      } else if (key == 'customText26') {
        profileOBJ.customText26 = value;
      } else if (key == 'customDate6') {
        profileOBJ.customDate6 = dateToTimestamp(value, this.rawCustomDate6);
      }else if (key == 'customText8') {
        profileOBJ.customText8 = value; 
      }else if (key == 'address2') {
        addressOBJ.address2 = value;
      } else if (key == 'city') {
        addressOBJ.city = value;
      } else if (key == 'state') {
        addressOBJ.state = value;
      } else if (key == 'zip') {
        addressOBJ.zip = value;
      } else if (key == 'candidateAddressCountryId') {
        addressOBJ.countryID = value;
      } else if (key == 'email') {
        profileOBJ.email = value;
      } else if (key == 'dateOfBirth') {
        profileOBJ.dateOfBirth = dateToTimestamp(value, this.dateOfBirth);
      } else if (key == 'gender') {
        profileOBJ.gender = value;
      } else if (key == 'nickName') {
        profileOBJ.nickName = value;
      } else if (key == 'namePrefix') {
        profileOBJ.namePrefix = value;
      } else if (key == 'firstName') {
        profileOBJ.firstName = value;
      } else if (key == 'lastName') {
        profileOBJ.lastName = value;
      } else if (key == 'customText13') {
        profileOBJ.customText13 = value;
      } else if (key == 'customText11') {
        profileOBJ.customText11 = value;
      } else if (key == 'mobile') {
        profileOBJ.mobile = value;
      } else if (key == 'customText36') {
        profileOBJ.customText36 = value;
      } else if (key == 'customText37') {
        profileOBJ.customText37 = value;
      } else if (key == 'email3') {
        profileOBJ.email3 = value;
      } else if (key == 'phone3') {
        profileOBJ.phone3 = value;
      } else if (key == 'id') {
        profileOBJ.id = value;
      }
      if (this.customText11 && this.customText11.length > 0) {
        profileOBJ.customText11 = this.customText11;
      }
    }
    this.name = data.firstName.trim();
    this.lastname = data.lastName.trim();
    this.email = data.email;
    if (Object.keys(addressOBJ) && Object.keys(addressOBJ).length > 0) {
      profileOBJ.address = addressOBJ;
    }
    var url = `${environment.apiConfig.uri}/admin/Candidates/UpdateCandidate/${this.candidateID}`;
    this.http.put<any>(url, profileOBJ).subscribe((response) => {
      var newData = JSON.parse(response.data).data;
      this.togglePopUp();
      this.update = false;
      this.formSession = false;
      if (response.isSuccess == true) {       
        setTimeout(() => {
          this.closeModelProfile.nativeElement.click();
          this.savedetailsModal = false;
        }, 1000);
        this.closeModelProfile.nativeElement.click();
      }
      if (this.pageName) {
        this.navigate = true;
        this.router.navigate([this.pageName]);
      }
    });

  }

  togglePopUp() {
    if (this.saving == true) {
      this.saving = false;
    } else {
      this.saving = true;
    }
  }
  ClosePopUp() {
    this.saving = false;
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
